export default "__VITE_ASSET__BzdZ5d3T__"